import { Pipe, PipeTransform } from '@angular/core';
import { SmsDeliveryStatus } from '@/common/enums/SmsDeliveryStatus';

const SMS_DELIVERY_STATUS_CLASS_MAP: Record<SmsDeliveryStatus, string> = {
	[SmsDeliveryStatus.SENT]: 'text-success',
	[SmsDeliveryStatus.PENDING]: 'text-muted',
	[SmsDeliveryStatus.FAILED]: 'text-danger',
	[SmsDeliveryStatus.FAILED_UNKNOWN]: 'text-danger',
	[SmsDeliveryStatus.NO_PHONE]: 'text-warning',
};

const SMS_DELIVERY_STATUS_TOOLTIP_MAP: Partial<Record<SmsDeliveryStatus, string>> = {
	[SmsDeliveryStatus.PENDING]: 'SMS oczekuje na wysyłkę',
	[SmsDeliveryStatus.FAILED]: 'Nie udało się wysłać SMS',
	[SmsDeliveryStatus.FAILED_UNKNOWN]: 'Nieznany błąd wysyłki SMS',
	[SmsDeliveryStatus.NO_PHONE]: 'Brak numeru telefonu',
};

@Pipe({
	name: 'smsDeliveryStatusClass',
	standalone: true,
	pure: true,
})
export class SmsDeliveryStatusClassPipe implements PipeTransform {
	transform(deliveryStatus: SmsDeliveryStatus | null, type: 'class' | 'tooltip' = 'class'): string | null {
		if (type === 'tooltip') {
			if (deliveryStatus === null || deliveryStatus === SmsDeliveryStatus.SENT) {
				return null;
			}
			return SMS_DELIVERY_STATUS_TOOLTIP_MAP[deliveryStatus] ?? null;
		}

		if (deliveryStatus === null) {
			return 'text-muted';
		}

		return SMS_DELIVERY_STATUS_CLASS_MAP[deliveryStatus] ?? 'text-muted';
	}
}
